import baseUrl from "../config/baseUrl";

const getProcessedUserCount = async ({ token, all = false }) => {
  try {
    const query = all ? "?all=1" : "";

    const response = await fetch(
      `${baseUrl}/api/get-processed-user-count-dashboard${query}`,
      {
        method: "GET",

        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default getProcessedUserCount;
